import { useState, Suspense } from "react";
import AdminMatchesList from "../../components/admin/AdminMatchesList.jsx"
import { Link, useParams } from "react-router-dom";

export default function MatchListPage() {
  const [tournamentFullName, setTournamentFullName] = useState()
  const {tournamentId} = useParams()

  const setTournamentFullNameOnLoad = (newTournamentName) => {
    setTournamentFullName(newTournamentName)
  }

  return (
    <section className="m-8">
      <div className="flex flex-row w-full">
        <h1 className="w-1/2">List of Matches: { tournamentFullName ? tournamentFullName : '' }</h1>
        <div className="w-1/2 text-end">
          <Link className="text-blue-500 underline hover:no-underline text-sm" to={`/cocofantoelefanto/tournaments/${tournamentId}/matches/new`}>Create New Match</Link>
        </div>
      </div>

      <div id="teams" className={`w-full pt-4'`}>
        <Suspense fallback={<p>Carregando...</p>}>
          <AdminMatchesList tournamentId={tournamentId} setTournamentFullNameOnLoad={setTournamentFullNameOnLoad}/>
        </Suspense>
      </div>
    </section>
  )
}
